<template>
  <div>
    <a-modal
      v-model="showModal"
      header
      footer
      :width="windowWidth"
      @cancel="handleModalClose"
      :class="`custom-recommend-modal ${
        reviewComplete ? 'modal-close-btn-white' : ''
      }`"
      @ok="handleModalOk"
      :centered="true"
      :dialog-style="{ margin: '0px' }"
      destroyOnClose="true"
      wrapClassName="modalWrappedClass"
    >
      <div
        v-if="!reviewComplete"
        class="recommend-container"
        :style="{ background: getPrimaryColor() }"
      >
        <div class="blue-part" :style="{ background: getPrimaryColor() }">
          <div
            v-if="selectedProfile"
            class="blue-content"
            :style="{ width: '300px' }"
          >
            <img
              v-if="getEntityImage()"
              :src="getEntityImage()"
              class="round"
              :style="{ border: '1px solid #F8FAFD' }"
            />
            <h4 class="white"><strong>You are Reviewing</strong></h4>
            <h1 class="white selected-profile-name mb-5">
              <b>{{ getReviewerLabel() }}</b>
            </h1>
            <a
              :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`"
              class="white guidelines hide-in-mobile"
              target="_blank"
              >Guidelines for Reviewing</a
            >
          </div>
        </div>
        <div class="white-container">
          <div class="white-part">
            <div v-for="(review, ind) in currentReviewArray" :key="ind">
              <div v-if="currentReview === ind">
                <p class="count">
                  {{ ind + 1 }} of {{ currentReviewArray.length }}
                </p>
                <h1 class="review-title">{{ review.heading }}</h1>
                <p class="rev-desc">{{ review.description }}</p>
                <div
                  v-if="ind < currentReviewArray.length - 1"
                  class="star-box"
                >
                  <a-icon
                    v-for="i in [1, 2, 3, 4, 5]"
                    :key="i"
                    class="star-rating-recommend"
                    :class="
                      i > currentReviewArray[ind].rating ? 'silver' : 'golden'
                    "
                    type="star"
                    @mouseover="getHover(i, ind)"
                    @mouseleave="removeHover(ind)"
                    @click="putRating(i)"
                    theme="filled"
                  />
                </div>
                <h3 v-if="ind < currentReviewArray.length - 1" class="rating">
                  {{ ratingConverter(currentReviewArray[ind].rating) }}
                </h3>
                <h3
                  v-if="geth && !ind < currentReviewArray.length - 1"
                  class="rating"
                >
                  {{ geth }}
                </h3>
                <div
                  v-if="ind === currentReviewArray.length - 1"
                  class="text-box"
                >
                  <a-textarea
                    :placeholder="
                      getReviewInputPlaceholder(selectedProfile.role)
                    "
                    v-model="currentReviewArray[ind].rating"
                    :rows="6"
                    :maxlength="5000"
                  />
                  <p class="text-right small-text">
                    {{
                      currentReviewArray[ind].rating
                        ? currentReviewArray[ind].rating.length
                        : 0
                    }}/5000
                  </p>
                </div>
                <div class="arrows">
                  <a-icon
                    v-if="currentReview > 0"
                    @click="currentReview = currentReview - 1"
                    type="left"
                  />
                  <!-- <a-icon v-if="currentReview > 0 && ind < currentReviewArray.length - 1" @click="currentReview = currentReview + 1" type="right" /> -->
                </div>
                <p
                  v-if="ind === currentReviewArray.length - 1"
                  class="small-text text-center gray900 font12 mb-3"
                >
                  By clicking “Submit” you agree to be at least 18 years old.
                </p>
                <button
                  @click="recommend"
                  v-if="ind === currentReviewArray.length - 1"
                  class="dovemed-button font-white w-100 mb-2"
                  :style="{ background: getPrimaryColor() }"
                >
                  {{ submitting ? "Submitting..." : "Submit" }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <a
          :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`"
          class="white guidelines show-in-mobile"
          target="_blank"
          >Guidelines for Reviewing</a
        >
      </div>
      <div
        v-if="reviewComplete"
        class="recommend-container"
        :style="{ background: getPrimaryColor() }"
      >
        <div
          class="blue-part w-100 end-height p-5"
          :style="{ background: getPrimaryColor() }"
        >
          <div v-if="selectedProfile" class="blue-content reviewDone">
            <img
              v-if="getEntityImage()"
              :src="getEntityImage()"
              alt
              class="round"
              :style="{ border: '1px solid #F8FAFD' }"
            />
            <h1 class="white font24">Thanks for reviewing</h1>
            <h1 class="white fw700">{{ getReviewerLabel() }}</h1>
            <!-- <div class="white-rate-container">
              <h3>YOUR RATING</h3>
              <div class="primary-dark-background font-white dovemed-button rate-area">
                <a-icon style="color: white" type="star" theme="filled" />
                {{ " " + entityRating }}
              </div>
            </div> -->
            <div
              class="d-flex flex-column bg-white br100 align-items-center"
              :style="{ padding: '24px 120px' }"
            >
              <h4 class="gray900 fw700 font24 mb-3">Your Rating</h4>
              <ReviewStar :rating="entityRating" :height="30" :width="30" />
              <p class="mb-0 mt-2 gray900 fw700 font20">
                {{ entityRating + " stars" }}
              </p>
            </div>
            <button
              @click="handleCloseReview"
              class="close dovemed-button font-white mt-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import ReviewStar from "../commons/ReviewStar.vue";

const UserRepository = RepositoryFactory.get("user");

export default {
  components: { ReviewStar },
  name: "RecommendOthers",
  props: {
    fetchReviews: { type: Function, default: () => {} },
    fetchUser: { type: Function, default: () => {} },
  },
  data() {
    return {
      reviewStarClicked: false,
      submitting: false,
      geth: null,
      showModal: false,
      windowWidth: 1000,
      defaultHospitalImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Hospital.svg",
      defaultClinicImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Clinic.svg",
      defaultNfpImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/nfp-icon.svg",
      selectedProfile: undefined,
      finalPopSize: null,
      entityRating: 0,
      reviewComplete: false,
      currentReview: 0,
      mobile: { margin: "0px", top: "0px", height: "100vh" },
      web: { top: "0px", height: "100vh ", width: "1000px !important" },
      hm: 0,
      // currentReviewArray: [
      //   {
      //     key: "ease_of_appointment",
      //     heading: "Ease of Appointment",
      //     description: "How easy was it to schedule an appointment?",
      //     rating: 0,
      //   },
      //   {
      //     key: "wait_time",
      //     heading: "Wait Time",
      //     description: "How satisifed were you about the wait time before seeing a doctor?",
      //     rating: 0,
      //   },
      //   {
      //     key: "friendliness",
      //     heading: "Friendliness Of The Staff",
      //     description: "How friendly was the staff?",
      //     rating: 0,
      //   },
      //   {
      //     key: "attentiveness",
      //     heading: "Attentiveness",
      //     description: "How well did your doctor listen to your concerns?",
      //     rating: 0,
      //   },
      //   {
      //     key: "quality_time",
      //     heading: "Quality Time",
      //     description: "Did you feel that your doctor spent enough time with you?",
      //     rating: 0,
      //   },
      //   {
      //     key: "politeness",
      //     heading: "Politeness",
      //     description: "How polite was your doctor?",
      //     rating: 0,
      //   },
      //   {
      //     key: "knowledge",
      //     heading: "Knowledge",
      //     description: "How well did your doctor explain your medical condition to you?",
      //     rating: 0,
      //   },
      //   {
      //     key: "length_of_visit",
      //     heading: "Length of Visit",
      //     description: "How much time did you spend with your doctor?",
      //     rating: 0,
      //   },
      //   {
      //     key: "description",
      //     heading: "Few words can be really powerful",
      //     description: "",
      //     rating: null,
      //   },
      // ],
      currentReviewArray: [
        // {
        //   key: "appointment",
        //   heading: "Ease of Appointment",
        //   description: "How easy was it to schedule an appointment?",
        //   rating: 0,
        // },
        // {
        //   key: "wait_time",
        //   heading: "Wait Time",
        //   description: "How satisifed were you about the wait time before seeing a doctor?",
        //   rating: 0,
        // },
        // {
        //   key: "friendliness_of_staff",
        //   heading: "Friendliness Of The Staff",
        //   description: "How friendly was the staff?",
        //   rating: 0,
        // },
        // {
        //   key: "attentiveness",
        //   heading: "Attentiveness",
        //   description: "How well did your doctor listen to your concerns?",
        //   rating: 0,
        // },
        // {
        //   key: "quality_time",
        //   heading: "Quality Time",
        //   description: "Did you feel that your doctor spent enough time with you?",
        //   rating: 0,
        // },
        // {
        //   key: "politeness",
        //   heading: "Politeness",
        //   description: "How polite was your doctor?",
        //   rating: 0,
        // },
        // {
        //   key: "knowledge",
        //   heading: "Knowledge",
        //   description: "How well did your doctor explain your medical condition to you?",
        //   rating: 0,
        // },
        // {
        //   key: "length_of_visit",
        //   heading: "Length of Visit",
        //   description: "How much time did you spend with your doctor?",
        //   rating: 0,
        // },
        // {
        //   key: "description",
        //   heading: "Few words can be really powerful",
        //   description: "",
        //   rating: null,
        // },
        {
          key: "wait_time",
          heading: "Wait Time",
          description: "How satisifed were you about the wait time?",
          rating: 0,
        },
        {
          key: "friendliness_of_staff",
          heading: "Friendliness Of The Staff",
          description: "How friendly was the staff?",
          rating: 0,
        },
        {
          key: "nursing_care",
          heading: "Nursing Care",
          description: "Are you satisfied with the quality of nursing care?",
          rating: 0,
        },
        {
          key: "courtesy_of_stuff",
          heading: "Courtesy Of Staff",
          description: "How easy was it to schedule an appointment?",
          rating: 0,
        },
        {
          key: "cleanliness",
          heading: "Cleanliness",
          description: "How well did your doctor listen to your concerns?",
          rating: 0,
        },
        {
          key: "clarity",
          heading: "Clarity",
          description:
            "Did you feel that your doctor spent enough time with you?",
          rating: 0,
        },
        {
          key: "community_service",
          heading: "Community Service",
          description:
            "Do you think the hospital/clinic does enough to reach out and engage the community?",
          rating: 0,
        },
        {
          key: "comment",
          heading: "Few words can be really powerful",
          description: "",
          rating: "",
          // rating: null,
        },
      ],
    };
  },
  created() {
    this.finalPopSize = this.screenSize < 581 ? this.mobile : this.web;
  },
  methods: {
    handleCloseReview() {
      this.$router.go(0);
      this.hide();
      this.reviewComplete = false;
      this.typeOfReview = "none";
      this.currentReview = 0;
      //   this.viewProfile({
      //     role: this.selectedProfile.role,
      //     id: this.selectedProfile.id
      //   });
      // this.viewEntityProfile(this.selectedProfile) to test
      // if (
      //   this.selectedProfile.role === "doctor" ||
      //   this.selectedProfile.role === "hcp"
      // ) {
      //   this.selectedProfile.ext_ref_id
      //     ? this.viewEntityProfile(this.selectedProfile)
      //     : this.viewProfile(this.selectedProfile);
      // }
      console.log("CLOSE REVIEW");
    },
    handleModalOk() {
      this.showModal = false;
    },
    handleModalClose() {
      this.showModal = false;
      setTimeout(() => {
        this.currentReview = 0;
      }, 500);
      // this.viewProfile(this.selectedProfile);
    },
    show(data) {
      this.showModal = true;
      this.selectedProfile = data;
      // console.log("this.viewUser ->", this.viewUser)
      // console.log("this.selectedProfile ->", this.selectedProfile)
      if (data.role.includes("clinic")) {
        this.currentReviewArray[6].description =
          "Do you think the clinic does enough to reach out and engage the community?";
      } else if (data.role.includes("hospital")) {
        this.currentReviewArray[6].description =
          "Do you think the hospital does enough to reach out and engage the community?";
      }
    },
    getHoverType(i, index, reviewType) {
      if (!reviewType[index].rating) {
        this.geth = this.ratingConverter(i);
        this.hm = document.getElementsByClassName("star-rating-recommend");
        for (let j = 0; j < 5; j++) {
          if (j < i) {
            this.hm[j].classList.remove("silver");
            this.hm[j].classList.add("golden");
          } else {
            this.hm[j].classList.add("silver");
            this.hm[j].classList.remove("golden");
          }
        }
      }
    },
    getHover(i, index) {
      this.getHoverType(i, index, this.currentReviewArray);
    },
    removeHoverType(index, reviewType) {
      this.geth = null;
      this.hm = document.getElementsByClassName("star-rating-recommend");
      if (!reviewType[index].rating) {
        for (let j = 0; j < 5; j++) {
          this.hm[j].classList.add("silver");
          this.hm[j].classList.remove("golden");
        }
      }
      this.hm = 0;
    },
    removeHover(index) {
      this.removeHoverType(index, this.currentReviewArray);
    },
    ratingConverter(num) {
      const array = [" ", "WORST", "POOR", "AVERAGE", "GOOD", "EXCELLENT"];
      return array[num];
    },
    putRating(i) {
      this.geth = null;
      this.currentReviewArray[this.currentReview].rating = i;
      if (!this.reviewStarClicked) {
        this.reviewStarClicked = true;
        setTimeout(() => {
          this.currentReview =
            this.currentReview + 1 < this.currentReviewArray.length
              ? this.currentReview + 1
              : this.currentReview;
          this.reviewStarClicked = false;
        }, 500);
      }
      // console.log("currentReview ->", this.currentReview)
    },
    hide() {
      this.showModal = false;
    },
    csvArray(arr) {
      return arr.join(", ");
    },
    getReviewerLabel() {
      switch (this.selectedProfile.role) {
        case "clinic":
        case "clinic_administrator":
          return this.selectedProfile.clinic_name
            ? this.selectedProfile.clinic_name
            : this.selectedProfile.clinic_info
            ? this.selectedProfile.clinic_info.clinic_name
            : this.selectedProfile.display_name;
        case "hospital":
        case "hospital_administrator":
          return this.selectedProfile.hospital_name
            ? this.selectedProfile.hospital_name
            : this.selectedProfile.hospital_info
            ? this.selectedProfile.hospital_info.hospital_name
            : this.selectedProfile.display_name;
        case "nfp":
        case "nfp_administrator":
          return this.selectedProfile.nfp_info
            ? this.selectedProfile.nfp_info.nfp_name
            : this.selectedProfile.nfp_name ||
                this.selectedProfile.display_name;
        default:
          return `${this.selectedProfile.first_name} ${this.selectedProfile.last_name}`;
      }
    },
    getEntityImage() {
      switch (this.selectedProfile.role) {
        case "clinic_administrator":
        case "clinic":
          return this.selectedProfile.clinic_info
            ? this.selectedProfile.clinic_info.picture ||
                this.defaultClinicImage
            : this.selectedProfile.url || this.defaultClinicImage;
        case "hospital_administrator":
        case "hospital":
          return this.selectedProfile.hospital_info
            ? this.selectedProfile.hospital_info.picture ||
                this.defaultHospitalImage
            : this.selectedProfile.url || this.defaultHospitalImage;
        case "nfp_administrator":
        case "nfp":
          return this.selectedProfile.nfp_info
            ? this.selectedProfile.nfp_info.picture || this.defaultNfpImage
            : this.selectedProfile.image ||
                this.selectedProfile.url ||
                this.defaultNfpImage;
        default:
          return "";
      }
    },
    async recommend() {
      if (this.submitting) {
        return;
      }
      const payload = {};
      let rate = 0;
      this.currentReviewArray.forEach((rev, i) => {
        payload[rev.key] = rev.rating;
        if (i < this.currentReviewArray.length - 1) {
          rate = rate + rev.rating;
        }
      });

      // payload["rating"] = Number((rate / (this.currentReviewArray.length - 1)).toFixed(1))
      // payload["user"] = this.authUser.user.id
      // payload["reviewer_id"] = this.authUser.user.id
      // payload["user_circle"] = this.currentCircle.id
      // payload["circle_id"] = this.currentCircle.id
      // payload["reviewer_role"] = this.authUser.user.role || ""
      // payload["reviewee_id"] = this.selectedProfile.ext_ref_id
      // payload["ext_ref_id"] = this.selectedProfile.ext_ref_id
      // payload[this.selectedProfile.role] = this.selectedProfile.is_virtual ? "" : this.selectedProfile.id
      // switch (this.selectedProfile.role) {
      //   case "clinic":
      //   case "hospital":
      //     payload["reviewee_role"] = `${this.selectedProfile.role}_administrator`
      //     payload["type"] = `${this.selectedProfile.role}_administrator`
      //     break
      //   case "other":
      //   case "hcp":
      //   case "ohcp":
      //     payload["reviewee_role"] = "hcp"
      //     payload["type"] = "hcp"
      //     break
      //   default:
      //     payload["reviewee_role"] = this.selectedProfile.role
      //     payload["type"] = this.selectedProfile.role
      // }
      // UserRepository.reviewEntityBasedOnType(payload, this.selectedProfile.role)
      //   .then(res => {
      //     if (res.data) {
      //       const newPayload = {}
      //       newPayload.page = this.selectedProfile.page ? this.selectedProfile.page - 1 : 0
      //       newPayload.circle_id = this.currentCircle.id
      //       this.$store.dispatch("Signup/getDoctors", newPayload)
      //       this.fetchUser(this.selectedProfile.page)
      //       this.reviewComplete = true
      //       let rate = 0
      //       this.currentReviewArray.forEach((rev, i) => {
      //         if (i < this.currentReviewArray.length - 1) {
      //           rate = rate + rev.rating
      //         }
      //       })
      //       this.entityRating = (rate / (this.currentReviewArray.length - 1)).toFixed(1)
      //     }
      //   })
      //   .catch(err => {
      //     this.$notification.error({
      //       message: "Failed",
      //       description: "Already Recomended",
      //     })
      //   })

      // CORE
      payload["overall"] = Number(
        (rate / (this.currentReviewArray.length - 1)).toFixed(1)
      );

      const headers = {
        Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`,
        dtoken:
          this.authUser.user.dovemed_csrf_token ||
          this.authUser.user.dovemed_session_token,
      };

      this.submitting = true;
      this.$http
        .post(
          `${
            process.env.SSO_BASE_URL
          }/api/v2/review/${this.getCoreReviewApiRole(
            this.selectedProfile.role
          )}/${this.selectedProfile.ext_ref_id}/review/`,
          payload,
          { headers }
        )
        // .post(`${process.env.SSO_BASE_URL}/api/v2/${this.getCoreReviewApiRole(this.selectedProfile.role)}/${this.selectedProfile.ext_ref_id}/review/`, payload, { headers })
        .then((res) => {
          this.submitting = false;
          this.$store.commit("User/setToggleReview");
          this.reviewComplete = true;
          this.entityRating = (
            rate /
            (this.currentReviewArray.length - 1)
          ).toFixed(1);
        })
        .catch(async (e) => {
          this.submitting = false;
          this.$notification.error({
            message: "Failed",
            description: "Try Again",
          });
          console.log("error: ", e);
          console.log(e.message);
          UserRepository.recordLogout();
          this.$store.dispatch("Auth/logout").then(() => {
            location.reload();
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .treatment-modal .ant-modal-centered .ant-modal {
    width: 100vw !important;
    margin: 0 !important;
    height: 100vh;
  }
  .input-type {
    font-size: 12px;
    padding: 0px;
  }
  .input-treatment-name {
    width: 80%;
  }
  .date-picker {
    width: 100%;
  }
  .currently-using {
    display: inline;
  }
  .date-picker {
    width: 50px;
  }
}

.ant-modal-centered .ant-modal {
  height: 100vh !important ;
  width: auto !important;
}

.ant-modal {
  width: auto !important;
  margin: 0px !important;
  padding: 0 !important;

  @media screen and (max-width: 767px) {
    margin: 0px !important;
  }
}

.ant-modal-wrap {
  overflow: hidden !important;
}

// .modalWrappedClass {
//   overflow: hidden !important;
//   .ant-modal-wrap {
//     overflow: hidden !important;
//   }
//   .ant-modal {
//     padding: 0 !important;
//   }
// }

// .blue-part {
//   @media screen and (max-width: 700px) {
//     min-height: 35vh;
//   }
// }
.white-container {
  width: 100%;
  @media screen and (max-width: 700px) {
    margin: 0 auto;
    width: auto;
  }
  .white-part {
    @media screen and (max-width: 700px) {
      min-height: 50vh;
      background: #ffffff;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 20px;
    }
  }
}
.selected-profile-name {
  // max-width: 200px;
  @media screen and (max-width: 900px) {
    max-width: 100%;
  }
}
.end-height {
  @media screen and (max-width: 900px) {
    // height: 100vh;
    height: 80vh;
  }
}
.recommend-container {
  @media screen and (max-width: 700px) {
    background: #0f74bd;
    min-height: 100vh;
  }
}

.guidelines {
  margin-top: 100px;
  line-height: 24px;
  text-align: center;
  text-decoration-line: underline;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/RecommendOthers.vue